var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentLoader,{tag:"component",on:{"on-seach":function($event){return _vm.$emit('on-search', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }